import React from 'react';
import './TrackRecord.css';

// Import relevant icons for the feature cards
import { FaProjectDiagram, FaHandshake, FaUserClock, FaUsers } from 'react-icons/fa';

// Data for the four feature cards
const trackRecordData = [
  {
    icon: <FaProjectDiagram />,
    title: '100+ projects delivered',
    description: 'First-hand experience driving results across 12+ countries.'
  },
  {
    icon: <FaHandshake />,
    title: '7+ knowledge partnerships',
    description: 'Collaborated with leading agri-tech firms, research institutions, and industry events.'
  },
  {
    icon: <FaUserClock />,
    title: '165+ person-years of expertise',
    description: 'A seasoned team with deep experience in research, advisory, sales, marketing & operations.'
  },
  {
    icon: <FaUsers />,
    title: '60+ clients served',
    description: 'Trusted by global and Indian leaders to deliver measurable value.'
  }
];

const TrackRecord = () => {
  return (
    <section className="track-record-section">
      <div className="track-record-container">
        <div className="section-header">
          <h2>Our track record</h2>
          <div className="header-line"></div>
        </div>

        <div className="track-record-grid">
          {trackRecordData.map((item, index) => (
            <div key={index} className="record-card">
              <div className="record-icon">{item.icon}</div>
              <h3>{item.title}</h3>
              <p>{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrackRecord;